<template>
  <div>
    <span class="cooperation-page__ticket-widget-title">
      {{$tCooperation('Place for widget')}}
    </span>
  </div>
</template>

<script>
  export default {
    mounted() {

      const script1 = document.createElement('script')
      script1.setAttribute('type', 'text/javascript')
      script1.setAttribute('src', 'https://www.e-podroznik.pl/public/jslib.do')
      this.$el.appendChild(script1)

      const script2 = document.createElement('script')
      script2.setAttribute('type', 'text/x-epodroznik-module')
      script2.setAttribute('data-module-name', 'UserMenu')
      script2.setAttribute('id', 'UserMenu')
      this.$el.appendChild(script2)

    }
  };
</script>